// For this project, file uploader is dumb. 
// All it does is upload file(s) and send file 
// object back to the parent component.
// Parent component handles:
// - Whether or not uploader is displayed,
// - Saving file obj for specific app purpose (e.g. conference logo),
// - Deleting a file,
// - Determining number of simultaneous uploads.

import {
  Component,
  EventEmitter,
  OnInit,
  Input,
  Output
} from '@angular/core';
import {
  UploadOutput,
  UploadInput,
  UploadFile,
  humanizeBytes,
  UploaderOptions,
  UploadStatus
} from 'ngx-uploader';

// Providers
import { FilesService } from '../../providers/files/files-service';
import { HelperService } from '../../providers/helpers/helper-service';
import { Config } from '../../providers/config/config';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html'
})
export class UploadComponent implements OnInit {
  @Input() uploadLabel = 'Drag and Drop Files Here to Upload';
  @Input() enabled = true;
  @Input() maxUploads = 5;
  @Input() public = 'No';

  @Output() fileRemoved = new EventEmitter<any>();
  @Output() fileAdded = new EventEmitter<any>();
  @Output() fileUploaded = new EventEmitter<any>();

  // File uploader stuff
  uploaderOptions: UploaderOptions;
  formData: FormData;
  files: UploadFile[];
  uploadInput: EventEmitter<UploadInput>;
  humanizeBytes: Function;
  dragOver: boolean;
  filePurpose = 'file';
  fileError = false;
  fileErrorMessage = '';
  fileUploading = false;
  fileDisplay: any = {
    file: []
  };

  constructor(
    private filesService: FilesService,
    private helperService: HelperService
  ) {
    this.uploaderOptions = { 
      concurrency: 1, 
      maxUploads: this.maxUploads 
    };

    // local uploading files array
    this.files = [];

    // input events, we use this to emit data to ngx-uploader
    this.uploadInput = new EventEmitter<UploadInput>();
    this.humanizeBytes = humanizeBytes;
  }

  onUploadOutput(output: UploadOutput): void {
    console.log(output);
    if (output.type === 'allAddedToQueue') {
      this.fileError = false;
      this.fileUploading = true;
      this.startUpload();
      console.log('fileUploading: ' + this.fileUploading);
    } else if (output.type === 'addedToQueue'  && typeof output.file !== 'undefined') { // add file to array when added
      this.files.push(output.file);
    } else if (output.type === 'uploading' && typeof output.file !== 'undefined') {
      // update current data in files array for uploading file
      const index = this.files.findIndex(file => typeof output.file !== 'undefined' && file.id === output.file.id);
      this.files[index] = output.file;
    } else if (output.type === 'removed') {
      // remove file from array when removed
      this.files = this.files.filter((file: UploadFile) => file !== output.file);
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
      this.dragOver = false;
    } else if (output.type === 'drop') {
      this.dragOver = false;
    } else if (output.type === 'done') {
      const fileObj = output.file.response;
      this.fileUploading = false;
      this.fileUploaded.emit( fileObj );
      console.log('fileUploading: ' + this.fileUploading);
    }
  }

  startUpload(): void {
    let access_token = Config.ACCESS_TOKEN;
    const event: UploadInput = {
      type: 'uploadAll',
      url: Config.API_ROOT_CORE + 'api/v1/files/upload',
      method: 'POST',
      data: { 
        project: Config.APP_NAME,
        public: this.public 
      },
      headers: { Authorization: `Bearer ${access_token}` }
    };
    this.uploadInput.emit(event);
  }

  clearFileDisplay() {
    this.fileDisplay.file.length = 0;
  }

  enableUpload() {
    this.enabled = true;
  }

  disableUpload() {
    this.enabled = false;
  }

  ngOnInit() {
    this.files = [];
  }
}



// WEBPACK FOOTER //
// ./src/components/file-upload/upload.component.ts